import { FilterList } from '@versita/frontend/campus-ui-web';
import { useAppDispatch } from '../../state';
import {
  FilterName,
  setStatusFilters,
} from '../../state/slices/timetableManagerSlice';

export const AdminTableFilters = () => {
  const dispatch = useAppDispatch();
  const publishedStatuses = [
    { label: 'Will Not Publish', value: 'willNotPublish' },
    { label: 'Published', value: 'published' },
    { label: 'Unpublished', value: 'unpublished' },
  ];

  const handleFilterByStatus = (selectedValues: FilterName[]) => {
    dispatch(setStatusFilters([...selectedValues]));
  };

  return (
    <FilterList
      items={publishedStatuses}
      filterDescription="Filter By Status"
      handleFilter={handleFilterByStatus}
    />
  );
};
